<template>
  <div class="main-container flex flex-center">
    <div class="main-box" style="overflow: hidden">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 1 }"
            @click="activeChange(1, 'time')"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 2 }"
            @click="activeChange(2, 'name')"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 3 }"
            @click="activeChange(3, 'stock')"
            >{{ $t("m.options.listTab.inventory") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 4 }"
            @click="activeChange(4, 'use')"
            >{{ $t("m.options.listTab.use") }}</span
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            class="active-icon"
            :class="share ? 'active': ''"
            @click="activeChange2()"
          >工厂推荐</el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
          <el-button type="primary"
          class="active-icon header-btn"
          @click="reset()"
          >
          <div style="display:flex;align-items: center;">
            <img src="@/assets/icons/reset.png" alt="" style="width: 18px;padding-right: 5px;">
            <span> {{ $t('m.common.reset') }}</span>
          </div>
      
          </el-button>
          <el-button
            v-if="!isDisabled"
              type="primary"
              icon="el-icon-plus"
              class="active-icon"
              @click="createBean()"
          >{{ $t("m.options.listTab.new") }}</el-button
          >
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 87px);position: relative;">
        <div
          class="box-content"
          style="max-height:calc(100% - 55px);"
        >
          <div
            @click="checkDevice(item)"
            :class="[
              item.id == activeBeanId
                ? 'box-item box-half box-active'
                : 'box-item box-half',
            ]"
            v-for="item in beanList"
            :key="item.id"
          >
            <div class="box-item-img">
              <img
                v-if="item.id == activeBeanId"
                src="../../assets/img/咖啡豆@2x.png"
              />
              <img v-else src="../../assets/img/咖啡豆@2x(1).png" />
              <div class="datetime">
                {{ $moment(Number(item.createtime)).format("YYYY-MM-DD") }}
              </div>
            </div>
            <div class="box-item-text">
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfName") }}：</span
                >
                <span class="text-value">{{ item.name }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfLevel") }}：</span
                ><span class="text-value">{{ item.level }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfOpreate2") }}：</span
                ><span class="text-value">{{ item.method }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfWeight")
                  }}{{ weight }}：</span
                ><span class="text-value">{{ item.stock }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-footer">
          <el-pagination
              v-show="beanPage.total > 0"
              background
              align="right"
              layout="prev, pager, next"
              @current-change="storagePageChange"
              :page-size="beanPage.pageSize"
              :total="beanPage.total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="main-box-footer">
        <span
          >{{ $t("m.deviceManage.deviceDetial.cfAllWeight") }}：{{
            beanAllWeight
          }}{{ weight }} | {{ $t("m.deviceManage.deviceDetial.kind") }}：{{
            beanKindCount
          }}{{ $t("m.deviceManage.deviceDetial.kind2") }}</span
        >
      </div>
    </div>
    <div class="main-box border-1px-all">
      <bean-detail
        v-if="refreshBeanDetail"
        :beanInfo="selectBean"
        :show-report-list="showReportList"
        :isAdd="isAdd"
        :is-disabled="isDisabled"
        :not-showedit="isDisabled"
      ></bean-detail>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div style="display: flex;gap: 10px;">
        <el-select
          v-model="searchParamKey"
          style="width: 120px;"
          placeholder=""
        >
          <el-option
            v-for="item in searchParamsKeyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <el-input
            v-model="searchParamValue"
            style="width: 100%;"
            :placeholder="$t('m.chart.table.placeholder3')"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="getBeanList" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import beanDetail from '@/components/bean/beanDetail'
import beanDetail from "@/components-online/storage/beanDetail";

export default {
  name: "storageStatus",
  components: {
    "bean-detail": beanDetail,
  },
  data() {
    return {
      weight: "kg",
      isAdd: false,
      beanList: [],
      beanPage: {
        pageSize: 50,
        pageNum: 1,
        total: 0,
      },
      beanKindCount: 0,
      beanAllWeight: 0,
      hasSearchParams: false,
      url: "/manage/bean/list",
      searchParamValue: "", //搜索框输入的值
      searchParamKey: "keyword",
      searchParamsKeyOptions: [
        { value: "keyword", label: "生豆名称" },
        { value: "supply", label: "供应商" },
      ],
      orderParamValue: "", //搜索框输入的值
      orderParamsKeyOptions: [
        { value: "/manage/bean/listAllByName.do", label: "首字母" },
        { value: "/manage/bean/listAllByStock.do", label: "库存" },
        { value: "/manage/bean/listAllByTime.do", label: "创建时间" },
        { value: "/manage/bean/listAllByCount.do", label: "用量" },
      ],
      beanCountUrl: "/manage/bean/count",
      beanDetailDialog: false,
      selectBean: {},
      showReportList: false,
      refreshBeanDetail: true,
      selectBeanIds: [],
      activeBeanId: 0,
      loading: undefined,

      active: 1,
      bean: "",
      deal: "",
      level: "",
      season: "",
      name: "",
      date: "",
      selectValue: "",
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      isDisabled: false,
      sort: 'time',
      share: false
    };
  },
  mounted() {
    // if (localStorage.role != 1) {
    //   this.isDisabled = true;
    // } else {
    //   this.isDisabled = false;
    // }
    this.weight = "(" + localStorage.weight + ")";
    this.getBeanList();
    this.getBeanCountInfo();
  },
  methods: {
    getBeanList() {
      let params = {
        pageNum: this.beanPage.pageNum,
        pageSize: this.beanPage.pageSize,
        share: this.share,
        sort: {
          column: this.sort
        }
      }
      if (this.searchParamValue) {
        if (this.searchParamKey == 'keyword') {
          params.keyword = this.searchParamValue;
        } else if (this.searchParamKey == 'supply') {
          params.supply = this.searchParamValue;
        }
      }
      this.$http
        .post(this.url, params)
        .then(
          function(resp) {
            this.beanList = resp.data.data.list;
            this.beanPage.total = resp.data.data.total;
            if (this.weight == "(g)") {
              for (let index in this.beanList) {
                this.beanList[index].bean.stock = this.weightTrans(
                  this.beanList[index].bean.stock
                );
              }
            }

            this.activeBeanId = resp.data.data.list[0].id;
            this.selectBean = resp.data.data.list[0];
            this.showReportList = true;
            this.refreshBeanDetail = false;
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            this.$nextTick(() => {
              this.refreshBeanDetail = true;
            });
            this.beanDetailDialog = true;
            this.dialogTableVisible = false;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
          this.dialogTableVisible = false;
        });
    },
    weightTrans(val) {
      //把kg转换成g
      return val * 1000;
    },
    getBeanCountInfo() {
      let url = this.beanCountUrl;
      this.$http
        .get(url)
        .then(
          function(resp) {
            console.info(resp);
            this.beanKindCount = resp.data.data.kinds;
            this.beanAllWeight = resp.data.data.stockSum;
            if (this.weight == "(g)") {
              this.beanAllWeight = this.weightTrans(this.beanAllWeight);
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      return this.$moment(date).format("YYYY-MM-DD");
    },
    checkDevice(item) {
      this.activeBeanId = item.id;
      console.info(item);
      this.selectBean = item;
      this.selectBean.owner = item.owner;
      this.showReportList = true;
      this.refreshBeanDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshBeanDetail = true;
      });
      this.beanDetailDialog = true;
    },
    createBean() {
      this.isAdd = true;
      this.showReportList = false;
      this.selectBean = {};
      this.refreshBeanDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshBeanDetail = true;
      });
    },
    activeChange(e, val) {
      this.active = e;
      this.sort = val;
      this.getBeanList();
    },
    storagePageChange(val) {
      this.beanPage.pageNum = val;
      this.getBeanList();
    },
    reset() {
      this.searchParamKey = "keyword";
      this.searchParamValue = '';
      this.share = false;
      this.getBeanList();
    },
    activeChange2() {
      this.share = true;
      this.getBeanList();
    }
  },
};
</script>

<style scoped lang="scss">
.box-content {
  gap: 15px;
}
.box-item.box-half {
  width: calc(50% - 10px) !important;
}
.el-select {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.box-item .box-item-img img {
  width: 65px;
}
.header-btn {
  padding: 12px 15px;
  font-size: 14px;
  font-weight: bold;
}
.box-header-right {
  display: flex;
}
.table-footer {
  position: absolute;
  bottom: 0;
  background: #07080900;
  padding-top: 10px;
  right: 0;
  width: 100%;
}
.el-button.active {
  border: 1px solid #FC9153 !important;
  color: #FC9153 !important;
}
</style>
